const decodeUnicodeEscapes = (s) => {
  if (!s || !s.includes("\\u")) return s;
  return s.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  ).replace(/\\u\{([0-9a-fA-F]+)\}/g, (_, hex) =>
    String.fromCodePoint(parseInt(hex, 16))
  );
};

// Convert Unicode superscript digits (²³¹⁰⁴⁵⁶⁷⁸⁹) to <sup> BEFORE NFKC normalization,
// which would otherwise flatten "83²" to a baseline "832". Only a run following a
// letter/digit/")" is treated as an exponent.
const SUPERSCRIPT_MAP = { "⁰": "0", "¹": "1", "²": "2", "³": "3", "⁴": "4", "⁵": "5", "⁶": "6", "⁷": "7", "⁸": "8", "⁹": "9" };
const preserveSuperscripts = (s) => {
  if (!s || !/[¹²³⁰⁴-⁹]/.test(s)) return s;
  return s.replace(/([A-Za-z\d)])([¹²³⁰⁴-⁹]+)/g, (_, base, sup) => {
    const digits = Array.from(sup).map((ch) => SUPERSCRIPT_MAP[ch] ?? "").join("");
    return `${base}<sup>${digits}</sup>`;
  });
};

// NFKC folds the Greek *symbol* variants onto their letter forms (ϕ→φ, ϑ→θ, ϖ→π …), which
// silently changes the operator symbol a maths question defines. Park them on private-use
// sentinels across the normalize() call and restore afterwards.
const GREEK_SYMBOL_VARIANTS = ["ϕ", "ϑ", "ϖ", "ϰ", "ϱ", "ϵ", "ϒ", "ϐ"];
const protectGreekSymbols = (s) =>
  GREEK_SYMBOL_VARIANTS.reduce(
    (acc, ch, i) => acc.split(ch).join(String.fromCharCode(0xe000 + i)),
    s
  );
const restoreGreekSymbols = (s) =>
  GREEK_SYMBOL_VARIANTS.reduce(
    (acc, ch, i) => acc.split(String.fromCharCode(0xe000 + i)).join(ch),
    s
  );

const decodeHtmlEntities = (s) => {
  if (!s || !s.includes("&")) return s;
  const textarea = document.createElement("textarea");
  textarea.innerHTML = s;
  const decoded = textarea.value;
  textarea.remove();
  return decoded;
};

export function normalizeExtractedDisplayText(text) {
  if (text == null || text === "") return text;
  let s = String(text);
  s = decodeUnicodeEscapes(s);
  s = decodeHtmlEntities(s);
  s = Array.from(s)
    .filter((ch) => {
      const code = ch.charCodeAt(0);
      const isAsciiControl =
        code === 0x7f || (code <= 0x1f && code !== 0x09 && code !== 0x0a && code !== 0x0d);
      return !isAsciiControl;
    })
    .join("");
  s = s.replace(/\u0372/g, "-");
  s = preserveSuperscripts(s);
  s = protectGreekSymbols(s);
  try {
    s = s.normalize("NFKC");
  } catch {
    /* ignore */
  }
  s = restoreGreekSymbols(s);
  s = s.replace(/([a-z])\.([A-Z])/g, "$1. $2");
  s = s.replace(/([a-z]),([A-Z])/g, "$1, $2");
  return s;
}
